export function getRelativeUserTimeZoneDifference(): string {
	const usersTimeZone = new Date().getTimezoneOffset();
	const negative = usersTimeZone < 0;
	const hours = Math.floor(Math.abs(usersTimeZone / 60));
	const minutes = Math.abs(usersTimeZone % 60);
	// if offset to UTC is negative, the TZ is after UTC (so - becomes +)
	return `${negative ? '+' : '-'}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
